import React from 'react';
import { AlternateLanguage, PageContextType } from 'src/types';

export type AppContextType = {
    pageContext: PageContextType;
    alternateLanguages: AlternateLanguage[];
    options: {
        show_navigation_header: boolean;
        show_footer: boolean;
    };
    homePage: string;
};

export const AppContext: React.Context<AppContextType> = React.createContext({
    alternateLanguages: [{ id: '', type: '', lang: '', uid: '' }],
    homePage: '',
    options: { show_navigation_header: false as boolean, show_footer: false as boolean },
    pageContext: { id: '', type: '', lang: '', uid: '', url: '' },
});

export function withAppContext(Component: any) {
    return (props: any) => (
        <AppContext.Consumer>{context => <Component {...props} context={context} />}</AppContext.Consumer>
    );
}
